import React from 'react';
import $ from 'jquery';
import { execJS } from '../utils/utils';
import { dispatchAlert } from '../utils/site-utils';
import { emailCheck, getFullUrlPath} from '../utils/common'
import Config from '../utils/config';
import Label from '../utils/label';

const OptionItem = props => {
	const onClick = () => {
		props.onClick(props.id, props.text);
	};

	return <a className="dropdown-item" href="javascript:void(0);" onClick={onClick} title={props.text}>{props.text}</a>;
};

export default class PopupForgot extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			showOptions: false,
			sQuestionID: '',
			sQuestionText: Label.lbl_Securitycode,
			sQuestionCode: '',
			sQuestionMail: '',
			optionsItems: [],
			lbl_CallHelp: ''
		};
	}
	
	componentDidMount() {
		// var self = this;
		$.ajax({
			url: getFullUrlPath('getOption.ashx?setPara=SQ'),
			dataType: 'json',
			async: false,
			success: data => {
				const optionsItems = data.Data.map(d => ({
					id: d.ItemArray[2],
					text: d.ItemArray[1]
				}));
				const lbl_CallHelp = data.lbl_CallHelp;

				this.setState({
					optionsItems,
					lbl_CallHelp
				});
			}
		});

	}

	onSelectClick = (id, text) => {
		this.setState({
			sQuestionID: id,
			sQuestionText: text,
			showOptions: false
		});
	};

	checkValue = value => {
		if (!this.state.sQuestionMail) {
			dispatchAlert(`${Label.lbl_YourEmail} ${Label.lbl_EmptyInput}`);
			return;
		}
		if (!emailCheck(this.state.sQuestionMail)) {
			dispatchAlert(`${Label.lbl_YourEmail} ${Label.lbl_Worngfromat}`);
			return;
		}
		if (!this.state.sQuestionID) {
			dispatchAlert(`${Label.lbl_Securitycode} ${Label.lbl_NotSelect}`);
			return;
		}
		if (!this.state.sQuestionCode) {
			dispatchAlert(`${Label.lbl_SecurityAnswer} ${Label.lbl_EmptyInput}`);
			return;
		}
		$.ajax({
			type: 'post',
			url: getFullUrlPath('Forget'),
			data:JSON.stringify({
				'email': this.state.sQuestionMail,
				'securityQID': this.state.sQuestionID,
				'securityCode': this.state.sQuestionCode
			}) ,
			contentType: 'application/json;charset=UTF-8;',
			async: false,
			success: data => {dispatchAlert(data.ErrorMsg);}
		});
	};

	showOptions = () => {
		this.setState({ showOptions: true });
	};

	hiddenOptions = () => {
		this.setState({ showOptions: false });
	};

	taggetOptions = () => {
		this.setState({ showOptions: !this.state.showOptions });
	}

	popupDiv(type) {
		this.props.popupDiv(type);
	}

	handleInputChange = event => {
		const value = event.target.value;
		const name = event.target.name;

		this.setState({
			[name]: value
		});
	};

	render() {
		// var self = this;

		const _SiteId = Config.appConfig.SiteID;
		return (
			<div className="blocker">
				{_SiteId == '4217000' || _SiteId == '4218500' || _SiteId == '4206300' || _SiteId == '4236500' ? (
					<div className="modal popup-forgot">
						<a
							href="javascript:void(0);"
							onClick={this.popupDiv.bind(this, -1)}
							title="Close"
							className="close"
						>
							<i className="icon-close" />
						</a>
						<h2>
							<div dangerouslySetInnerHTML={{ __html: this.state.lbl_CallHelp }} />
						</h2>
					</div>
				) : (
					<div className="modal popup-forgot">
						<a
							href="javascript:void(0);"
							onClick={this.popupDiv.bind(this, -1)}
							title="Close"
							className="close"
						>
							<i className="icon-close" />
						</a>
						<h2>{Label.lbl_Forget}</h2>
						<p className="txt">{Label.lbl_ForgetNote}</p>
						<form action="">
							<label className="login__item">
								<div className="box-bg">
									<input
										id="sQuestionMail"
										name="sQuestionMail"
										type="text"
										autoComplete="on"
										placeholder={Label.lbl_YourEmail}
										value={this.state.sQuestionMail}
										onChange={this.handleInputChange}
									/>
								</div>
							</label>
							<label className="login__item">
								<div className="box-bg">
									<div
										className={"dropdown " + (this.state.showOptions ? 'open' : '')}
										onClick={this.taggetOptions}
									>
										<div 
											className={"dropdown-toggle btn btn-outline " + (this.state.showOptions ? 'current' : '')}
										>
											{this.state.sQuestionText}
										</div>
										<div className="dropdown-menu">
											{this.state.optionsItems.map((item, i) => (
												<OptionItem key={i} id={item.id} text={item.text} onClick={this.onSelectClick} />
											))}
										</div>
									</div>
								</div>	
							</label>
							<label className="login__item">
								<div className="box-bg">
									<input
										id="sQuestionCode"
										name="sQuestionCode"
										type="text"
										placeholder={Label.lbl_SecurityAnswer}
										value={this.state.sQuestionCode}
										onChange={this.handleInputChange}
									/>
								</div>
							</label>
							<div 
								className="btn btn-primary btn-block btn-large" 
								onClick={this.checkValue}
							>
								{Label.lbl_Submit}
							</div>
						</form>
					</div>
				)}
			</div>
		);
	}
}
